export enum ERole {
    SUPER_ADMIN = "super_admin",
    COMPANY_ADMIN = "company_admin",
}